import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Heart, MapPin } from "lucide-react";

const heartPin = L.divIcon({
  className: "",
  html: `<div style="position:relative;width:44px;height:44px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="#FF453A" stroke="#fff" stroke-width="1.2" style="filter:drop-shadow(0 4px 10px rgba(255,69,58,0.55));">
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#fff" style="position:absolute;top:9px;left:15px;">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
    </svg></div>`,
  iconSize: [44, 44],
  iconAnchor: [22, 42],
});

const smallPin = (color) =>
  L.divIcon({
    className: "",
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="${color}" stroke="#fff" stroke-width="1.4" style="filter:drop-shadow(0 3px 6px rgba(0,0,0,0.3));">
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/>
      <circle cx="12" cy="10" r="3" fill="#fff" stroke="none"/></svg>`,
    iconSize: [28, 28],
    iconAnchor: [14, 26],
  });

const FIRST_DATE = [40.7359, -73.9911];
const spots = [
  { pos: [40.7411, -73.9897], label: "Where we met", color: "#F59E0B" },
  { pos: [40.7308, -73.9973], label: "First kiss", color: "#34C759" },
  { pos: [40.7291, -73.9845], label: "That tiny restaurant", color: "#3B82F6" },
];

export default function FirstDateMap() {
  return (
    <section className="py-24 border-t border-[#2A3042]" data-testid="first-date-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#FF453A] mb-4 flex items-center justify-center gap-2">
            <Heart size={13} className="fill-[#FF453A]" /> For couples
          </p>
          <h2 className="font-heading font-semibold text-3xl sm:text-4xl tracking-tight text-white">
            Remember our first date?
          </h2>
          <p className="mt-4 text-[#9BA1B0] max-w-xl mx-auto leading-relaxed">
            Send them one question — <span className="text-white font-medium">"Where was our first date?"</span> —
            and watch them hunt the map for the exact spot. When the pin lands, your story unlocks.
          </p>
        </div>
        <div data-testid="first-date-map" className="relative rounded-3xl overflow-hidden border-4 border-[#2A3042] shadow-2xl">
          <MapContainer
            center={[40.7355, -73.9905]}
            zoom={14}
            scrollWheelZoom={false}
            style={{ height: "460px", width: "100%", zIndex: 0 }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'
              url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={FIRST_DATE} icon={heartPin}>
              <Popup>Our first date — the coffee shop that ran out of coffee.</Popup>
            </Marker>
            {spots.map((s) => (
              <Marker key={s.label} position={s.pos} icon={smallPin(s.color)}>
                <Popup>{s.label}</Popup>
              </Marker>
            ))}
          </MapContainer>
          <div className="absolute top-4 left-4 z-[400] rounded-2xl bg-white shadow-xl px-5 py-4 max-w-[280px]">
            <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#FF453A] mb-1.5">Clue #2 of 12 — Our Story</p>
            <p className="font-heading font-semibold text-[#1a1d29] text-[15px] leading-snug">
              "Where was our first date?"
            </p>
            <p className="mt-1.5 text-xs text-[#6b7080]">Drop your pin on the exact spot 💌</p>
          </div>
          <div className="absolute bottom-4 right-4 z-[400] rounded-full bg-[#FF453A] shadow-xl px-6 py-3 flex items-center gap-2">
            <MapPin size={15} className="text-white" />
            <span className="text-white text-sm font-semibold">Lock In My Pin</span>
          </div>
        </div>
      </div>
    </section>
  );
}
